import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ProfileSetupPromptState {
  promptedByUserId: Record<string, boolean>;
  hasPrompted: (userId: string | undefined | null) => boolean;
  markPrompted: (userId: string | undefined | null) => void;
  clearPrompted: (userId: string | undefined | null) => void;
  resetAll: () => void;
}

export const useProfileSetupPrompt = create<ProfileSetupPromptState>()(
  persist(
    (set, get) => ({
      promptedByUserId: {},
      hasPrompted: (userId) => {
        if (!userId) return false;
        return Boolean(get().promptedByUserId[userId]);
      },
      markPrompted: (userId) => {
        if (!userId) return;
        set((state) => ({
          promptedByUserId: { ...state.promptedByUserId, [userId]: true },
        }));
      },
      clearPrompted: (userId) => {
        if (!userId) return;
        set((state) => {
          const next = { ...state.promptedByUserId };
          delete next[userId];
          return { promptedByUserId: next } as ProfileSetupPromptState;
        });
      },
      resetAll: () => set({ promptedByUserId: {} }),
    }),
    { name: "henlo-profile-setup-prompt" },
  ),
);
